import React, { useCallback, useEffect, useState } from 'react'
import { AfterPayBanner, EmptyProductsFallback } from '../../components'
import { BREADCRUMB, HELPBUTTON, PAGETITLE, PAYPALBANNER, PRODUCTTILES } from '../../constants/rootElements'
import { Breadcrumb } from '../breadcrumb'
import { HelpButton } from '../help'
import { ProductBrowseTiles } from "../home/productBrowseTiles"
import { TitleBar } from "../productBrowseTitle"
import { useGoogleAnalyticsHandler } from '../../hooks'

export const FRBPage = props => {
    const { appData } = props
    const [pbData, setPbData] = useState({})
    const [breadcrumbData, setBreadcrupmData] = useState([])
    const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);
    const [currencyCode, setCurrencyCode] = useState(null);

    const TitleBarPC = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseTitle")
    const BreadcrumbPC = Boolean(appData?.pagecontentData?.find(data => data.contentType === "Navigation"))
    const ProductBrowseProducts = appData?.pagecontentData?.find(data => data.contentType === "ProductBrowseProducts")
    const PaypalBannerData = appData?.pagecontentData?.find(data => data.contentType === "PaypalId")
    const PaymentOptions = appData?.pagecontentData?.find(data => data.contentType === "PaymentOptions")

    const { selectItemTrackingGASY25, viewModalTrackingGASY25, addToCartTrackingGASY25 } = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

    const getBreadcrumb = useCallback(() => {
        BREADCRUMB.render(<Breadcrumb pbData={breadcrumbData} />);
    }, [breadcrumbData])

    const productTiles = useCallback(() => {
        PRODUCTTILES.render(
            !!pbData?.products?.length
                ? <ProductBrowseTiles
                    pbData={pbData}
                    pageContent={ProductBrowseProducts}
                    paymentOptions={PaymentOptions}
                    googleAnalytics={{ 
                        selectItemTrackingGASY25, 
                        viewModalTrackingGASY25, 
                        addToCartTrackingGASY25,
                        catalogOSR: googleAnalyticsRequestData?.catalogOsr,
                        customerClassCode: appData.affiliationData?.customerClassCode
                    }}
                    sectionTitle={ProductBrowseProducts?.title || 'FRB'}
                />
                : <EmptyProductsFallback
                    productBrowseData={pbData}
                />
        )
        // eslint-disable-next-line
    }, [pbData, PaymentOptions, ProductBrowseProducts, selectItemTrackingGASY25])

    const paypalBanner = useCallback(() => {
        PAYPALBANNER.render(<AfterPayBanner currencyCode={currencyCode} />);
    },[PaypalBannerData, currencyCode])

    const getHelpButton = useCallback(() => {
        HELPBUTTON.render(<HelpButton />);
    }, [])

    const getTitleBar = useCallback(() => {
        PAGETITLE.render(<TitleBar pageContent={TitleBarPC} affiliationData={appData?.affiliationData}/>);
      },[])

    useEffect(() => {
        appData.productBrowseData && Object.keys(appData.productBrowseData).map((key) => {
            if (key !== "metaData") {
                const catalog = appData.productBrowseData[key];
                catalog?.productGroups && Object.keys(catalog.productGroups).map((catObj) => {
                    const productGroup = catalog.productGroups[catObj];
                    setPbData(productGroup)
                    const _currencyCode = productGroup?.products?.[0]?.currencyCode;
                    _currencyCode && setCurrencyCode(_currencyCode);
                    setBreadcrupmData(productGroup)
                    const customerNumber = appData.productBrowseData.metaData.customerNumber;
                    setGoogleAnalyticsRequestData({
                        customerNumber,
                        publishedCatalogId: catalog.publishedCatalogId,
                        sourceCatalogType: catalog.sourceCatalogType,
                        catalogOsr: catalog.catalogOsr,
                        customerClassCode: appData.affiliationData?.customerClassCode
                    });
                    return true
                })
            }
            return true
        })
    }, [appData.productBrowseData])

    return (
        <>
            {
                TitleBarPC && Object.keys(TitleBarPC)?.length > 0 && getTitleBar()
            }
            {
                BreadcrumbPC && getBreadcrumb()
            }
            {
                ProductBrowseProducts && Object.keys(ProductBrowseProducts)?.length > 0 && productTiles()
            }
            {
                getHelpButton()
            }
            {
                PaypalBannerData && Object.keys(PaypalBannerData)?.length > 0 && paypalBanner()
            }

        </>
    )
}
